const map = {
	"./bear.webp": 2471,
	"./cat.webp": 3571,
	"./deer.webp": 1234,
	"./fox.webp": 62,
	"./frog.webp": 9715,
	"./hedgehog.webp": 3608,
	"./kangaroo.webp": 8703,
	"./koala.webp": 9745,
	"./lion.webp": 1851,
	"./monkey.webp": 3596,
	"./owl.webp": 4981,
	"./panda.webp": 3375,
	"./penguin.webp": 4027,
	"./puppy.webp": 2229,
	"./rabbit.webp": 7957,
	"./tiger.webp": 3468
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9671;